module.exports = __webpack_public_path__ + "static/media/intro.79cc3f96.mp3";